import React from 'react';
import PropTypes from 'prop-types';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import { t } from 'i18n/index';

import './SecretLocation.css';

const SecretLocation = ({ location }) => {
  const text = location || t('literal:secretVenueFallback');

  return (
    <div className="secret-location" role="region" aria-label={text}>
      <svg className="secret-location__topo" viewBox="0 0 280 280" aria-hidden="true">
        <circle className="solid" cx="140" cy="140" r="36" />
        <circle cx="140" cy="140" r="58" />
        <circle cx="140" cy="140" r="80" />
        <circle cx="140" cy="140" r="104" />
        <circle cx="140" cy="140" r="128" />
        <circle cx="140" cy="140" r="150" />
      </svg>

      <span className="secret-location__seal" aria-hidden="true">
        <span className="secret-location__seal-inner">
          <LockOutlinedIcon />
        </span>
      </span>

      <div className="secret-location__body">
        <p className="secret-location__text">{text}</p>
        <span className="secret-location__rule" aria-hidden="true" />
      </div>
    </div>
  );
};

SecretLocation.propTypes = {
  location: PropTypes.string,
};

export default SecretLocation;
